import reportError from '@rover/utilities/reportError';

const retry = (fn, retriesLeft = 5, interval = 1000) =>
  new Promise((resolve, reject) =>
    fn()
      .then(resolve)
      .catch(error => {
        if (retriesLeft === 0) {
          reportError(error);
          reject(error);
          return;
        }
        setTimeout(() => {
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      })
  );

export default retry;



// WEBPACK FOOTER //
// ../utilities/retry.client.js